export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED';

export const loginSuccess = (user) => {
    let readOnlyRole = user.roleResources.find(item => item.name === 'READONLY');
    let fullAccessRole = user.roleResources.find(item => item.name === 'FULL_ACCESS');
    let creatorRole = user.roleResources.find(item => item.name === 'CREATOR');
    let approverRole = user.roleResources.find(item => item.name === 'APPROVER');
    let authorizerRole = user.roleResources.find(item => item.name === 'AUTHORIZER');
    let bulkFxUpdateRole = user.roleResources.find(item => item.name === 'BULKFXUPDATE');
    let approverRoleExtRole = user.roleResources.find(item => item.name === 'APPROVER_EXT');
    let batchUploadRole = user.roleResources.find(item => item.name === 'BATCH_UPLOAD');
    
    user.role = {
        readOnly: readOnlyRole ? true : false,
        fullAccess: fullAccessRole ? true : false,
        creator: creatorRole ? true : false,
        approver: approverRole ? true : false,
        authorizer: authorizerRole ? true : false,
        bulkFxUpdate: bulkFxUpdateRole ? true : false,
        approverExt: approverRoleExtRole ? true : false,
        batchUpload: batchUploadRole? true: false
    }

    return {
        type: USER_LOGIN_SUCCESS,
        currentUser: user,
    }
}

export const loginFailed = () => {
    return {
        type: USER_LOGIN_FAILED,
        currentUser: null
    }
}